// extracted by mini-css-extract-plugin
export default {"main":"RootLayout_main__eL0AN"};